import deepseekSvg from "../../../assets/deepseek-color.svg";
import qwenSvg from "../../../assets/qwen-color.svg";
import gemmaWebp from "../../../assets/gemma.webp";
import upiSvg from "../../../assets/UPI-Color.svg";
import opencodeSvg from "../../../assets/opencode.svg";
import openclawSvg from "../../../assets/openclaw-color.svg";
import kilocodeSvg from "../../../assets/kilocode.svg";
import openwebuiSvg from "../../../assets/openwebui.svg";
import desktopPng from "../../../assets/kratoai.png";
import paymentIcon from "../../../assets/icons8-card-payment-50.png";

export type PitchSlide = {
  eyebrow: string;
  title: string;
  subtitle?: string;
  layout?: "standard" | "cover";
};

export const slidesMeta: PitchSlide[] = [
  {
    eyebrow: "Slide 1 - Cover",
    title: "Krato AI",
    subtitle: "Open Models. Indian Infrastructure. Developer Freedom.",
    layout: "cover",
  },
  {
    eyebrow: "Slide 2 - The Problem",
    title: "Every Indian startup paying OpenAI is funding someone else's AI future.",
  },
  {
    eyebrow: "Slide 3 - Our Solution",
    title: "The AI infrastructure layer India was waiting for.",
  },
  {
    eyebrow: "Slide 4 - Open Weight Models",
    title: "The world's best open models. Production-ready, today.",
  },
  {
    eyebrow: "Slide 5 - API Compatibility",
    title: "Your existing code works. Right now.",
  },
  {
    eyebrow: "Slide 6 - Pluggable RAG",
    title: "AI that knows your business - not just the internet.",
  },
  {
    eyebrow: "Slide 7 - Ecosystem",
    title: "Works with everything you already love.",
  },
  {
    eyebrow: "Slide 8 - Unit Economics",
    title: "The numbers work - from the first token.",
  },
  {
    eyebrow: "Slide 9 - Why Krato AI / The Vision",
    title: "This isn't just a cheaper API. It's a different philosophy.",
  },
  {
    eyebrow: "Slide 10 - The Ask / MVP Plan",
    title: "Seed Round - What we're building and what we need.",
  },
  {
    eyebrow: "Slide 11 - Closing",
    title: "India builds the world's software. It's time India runs its own AI.",
  },
];

export const coverLogos = [
  { src: deepseekSvg, alt: "DeepSeek logo" },
  { src: qwenSvg, alt: "Qwen logo" },
  { src: gemmaWebp, alt: "Gemma logo" },
  { src: upiSvg, alt: "UPI logo" },
];

export const modelCards = [
  [deepseekSvg, "DeepSeek", "Reasoning-first open model"],
  [qwenSvg, "Qwen", "Alibaba's multilingual powerhouse"],
  [gemmaWebp, "Gemma", "Lightweight and efficient open model family"],
  [openwebuiSvg, "Open Source Stack", "Production-ready tooling for model operations"],
] as const;

export const codingAgents = [
  [kilocodeSvg, "KiloCode", "Your personal AI coding agent"],
  [opencodeSvg, "OpenCode", "AI coding agent for your IDE"],
  [openclawSvg, "OpenClaw", "AI-powered coding harness for teams"],
  [openwebuiSvg, "Open WebUI", "Open interface layer for local and hosted AI models"],
] as const;

export const showcaseAssets = {
  desktopPng,
  paymentIcon,
  upiSvg,
};
